import React, { useState, useRef } from 'react';
import { debounce } from 'lodash/fp';
import { unescape } from 'lodash';

const NewMessage = ({ messageData, applyChanges, handleUpdate }) => {
  const [message, setMessage] = useState(messageData.message || '');

  const saveMessage = newMessage => {
    const messageToSend = { message: newMessage };
    const dataToSend = { raw_choices: JSON.stringify(messageToSend) };
    applyChanges(dataToSend);
    handleUpdate(dataToSend);
  };
  const debouncedSaveMessage = useRef(debounce(300, saveMessage)).current;

  const handleMessageChange = e => {
    const { value } = e.target;
    setMessage(value);
    debouncedSaveMessage(value);
  };

  return (
    <div data-testid="NewMessage">
      <div className="EditorElement-label">
        {t('questions.question.chat.display_header')}
      </div>
      <textarea
        className="EditorElement-input"
        onChange={handleMessageChange}
        placeholder={t('questions.question.chat.enter_message')}
        value={unescape(message)}
      />
    </div>
  );
};

export default NewMessage;
